interface Logo {
  href: string
  src: string
  alt: string
}

interface NavLink {
  href: string
  label: string
}

interface RegisterLink {
  href: string
  label: string
}

import { getConventionRegisterPath } from '../registerConfig'

interface NavConfig {
  logo: Logo
  navLinks: NavLink[]
  registerLink: RegisterLink
  buttonClass: string
  linkClass: string
  hotelLink: string
}

const navConfig: NavConfig = {
  logo: {
    href: '/magic-conventions/magifest/',
    src: 'https://vinc.gumlet.io/pics/conventions/magifest/logo.png?w=1300&dpr=2',
    alt: 'Magifest Logo',
  },
  navLinks: [
    { href: '/magic-conventions/magifest/schedule/', label: 'Schedule' },
    { href: '/magic-conventions/magifest/hotel/', label: 'Hotel' },
    { href: '/magic-conventions/magifest/streaming/', label: 'Streaming' },
    { href: '/magic-conventions/magifest/dealers/', label: 'Dealers' },
    { href: '/magic-conventions/magifest/youth/', label: 'Youth' },
  ],
  registerLink: {
    href: getConventionRegisterPath('magifest'),
    label: 'Register Now',
  },
  buttonClass: 'border-[#aa8264] hover:bg-[#aa8264] hover:text-white!important',
  linkClass: 'hover:text-[#aa8264]',
  hotelLink:
    'https://book.passkey.com/gt/221308067?gtid=730e738b5246abafb65242568468240d',
}

export default navConfig
